import React from 'react';
import { hhmmToSeconds, secondsToHHmm } from '../../utils/time';
import { InputData, InputDiv, InputLabel } from './style';

export interface TimeFieldProps {
  label?: string;
  valueSeconds?: number | null;
  onChangeSeconds: (seconds: number | null) => void;
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  name?: string;
  className?: string;
  required?: boolean;
}

export const TimeField: React.FC<TimeFieldProps> = ({
  label,
  valueSeconds,
  onChangeSeconds,
  disabled,
  placeholder,
  id,
  name,
  className,
  required,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (!raw) {
      onChangeSeconds(null);
      return;
    }
    const seconds = hhmmToSeconds(raw);
    onChangeSeconds(seconds);
  };

  return (
    <InputDiv className={className}>
      {label && <InputLabel htmlFor={id}>{label}</InputLabel>}
      <InputData
        id={id}
        name={name}
        type="time"
        disabled={disabled}
        placeholder={placeholder}
        required={required}
        value={secondsToHHmm(valueSeconds ?? null)}
        onChange={handleChange}
      />
    </InputDiv>
  );
};

export default TimeField;
